import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/velvet/Nav";
import { Hero } from "@/components/velvet/Hero";
import { Manifesto } from "@/components/velvet/Manifesto";
import { Voices } from "@/components/velvet/Voices";
import { EditorialMarquee } from "@/components/velvet/Marquee";
import { Release } from "@/components/velvet/Release";
import { Lantern } from "@/components/velvet/Lantern";
import { Contact } from "@/components/velvet/Contact";

function App() {
  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("nolenis")) return;
    const lenis = new Lenis({
      duration: 1.25,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);

  return (
    <div className="App vt-grain" data-testid="velvet-testament-app">
      <Nav />
      <main>
        <Hero />
        <Manifesto />
        <Voices />
        <EditorialMarquee />
        <Release />
        <Lantern />
        <Contact />
      </main>
    </div>
  );
}

export default App;
